
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiClassiDialog extends Serenity.EntityDialog<UtentiProdottiClassiRow, any> {
        protected getFormKey() { return UtentiProdottiClassiForm.formKey; }
        protected getIdProperty() { return UtentiProdottiClassiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiClassiRow.localTextPrefix; }
        protected getService() { return UtentiProdottiClassiService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiClassiRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiClassiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiClassiRow.updatePermission; }

        protected form = new UtentiProdottiClassiForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove All Buttons
                buttons = [];
            }

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.idProdotto !== undefined)
                this.form.IdProdottoClasse.cascadeValue = this.idProdotto;

            if (!this.isNewOrDeleted())
                this.form.IdProdottoClasse.value = this.entity.IdProdottoClasse.toString();

            this.dialogTitle = "Classe dell'utente";

            this.set_readOnly(Q.Authorization.hasPermission("Role:SuperAdmin"));
        }

        // ///////////////////////////////////////////////////////////////
        private _idProdottoClasse: number;

        get idProdottoClasse() {
            return this._idProdottoClasse;
        }

        set idProdottoClasse(value: number) {
            if (this._idProdottoClasse != value) {
                this._idProdottoClasse = value;
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _idUtenteProdotto: number;

        get idUtenteProdotto() {
            return this._idUtenteProdotto;
        }

        set idUtenteProdotto(value: number) {
            if (this._idUtenteProdotto != value) {
                this._idUtenteProdotto = value;
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _idProdotto: number;

        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
            }
        }
    }
}